export default "__VITE_PUBLIC_ASSET__ffcaba00__"